import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthenticationService } from '../_services/auth/authentication.service';
import { catchError } from 'rxjs/operators';



@Injectable()
export class LogoutInterceptor implements HttpInterceptor {

  constructor(private customAuthService: AuthenticationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError((err:any) => {
        if(err.status === 418){ // I'm a teapot response
          this.customAuthService.logout();
          location.reload(true);
        }
        // const error = err.error.msg;
        return throwError(err);
      }
    ));
  }
}
